import React, { useCallback, useLayoutEffect, useState } from 'react';
import Animated from 'react-native-reanimated';
import { View, FlatList } from 'react-native';
import Text from 'design-system/Text';
import StatusBar from 'design-system/StatusBar';
import SectionHeader from 'design-system/SectionHeader';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { Button, rem, withAnimatedNavigationHeader, SCROLL_INDICATOR_INSETS, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useMarginBottom } from 'hooks/useMarginBottom';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { Weekdays } from '../types';
import { useCommonInvestStyles } from './styles';
import { strings } from '../components/OnboardingTitle';
import { isWeb } from '../../../constants';
const weekdayTextMap = [
    {
        title: 'Mon',
        enum: Weekdays.MONDAY,
    },
    {
        title: 'Tue',
        enum: Weekdays.TUESDAY,
    },
    {
        title: 'Wed',
        enum: Weekdays.WEDNESDAY,
    },
    {
        title: 'Thu',
        enum: Weekdays.THURSDAY,
    },
    {
        title: 'Fri',
        enum: Weekdays.FRIDAY,
    },
    {
        enum: undefined,
        title: 'placeholder',
    },
];
const SelectWeekdayScreen = withAnimatedNavigationHeader(({ route, navigation, navigation: { navigateDeprecated }, scrollHandler }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const { params } = route;
    const [day, selectDay] = useState(Weekdays.MONDAY);
    const commonStyles = useCommonInvestStyles();
    const marginBottom = useMarginBottom('marginBottom');
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const onSubmit = useCallback(() => {
        if (day && params) {
            navigateDeprecated('InvestHoliday', {
                ...params,
                buyConfig: {
                    day,
                    interval: params.interval,
                },
            });
        }
    }, [day, params]);
    return (<View style={commonStyles.containerNoPadding}>
        <StatusBar barStyle="dark-content" animated/>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={paddingHorizontalStyle}>
          <ScreenInfoHeader preTitle="Weekly" style={styles.screenInfoHeader} title={strings.SelectWeekday.title} subTitle={strings.SelectWeekday.subtitle}/>
          <SectionHeader horizontalMargins largeVerticalMargins>
            Day of the week
          </SectionHeader>
          <View style={styles.daysWrapper}>
            <FlatList numColumns={3} data={weekdayTextMap} scrollEnabled={false} contentContainerStyle={styles.contentContainerStyles} columnWrapperStyle={styles.columnWrapperStyle} renderItem={({ item }) => (<View style={styles.eachButtonContainer}>
                  {item.enum ? (<TouchableBounce style={[styles.buttonStyles, day === item.enum && styles.selectedContainer]} onPress={() => selectDay(item.enum)}>
                      <Text Text-16 {...(day === item.enum ? { Primary: true } : { Secondary: true })}>
                        {item.title}
                      </Text>
                    </TouchableBounce>) : null}
                </View>)}/>
          </View>
        </Animated.ScrollView>
        <View style={paddingHorizontalStyle}>
          <View style={styles.infoContainer}>
            {!!day && (<Text TextThin-16 Secondary centered>
                Your order will be placed every{' '}
                <Text Text-16 Secondary>
                  week
                </Text>
                {'\n'}
                on{' '}
                <Text Text-16 Secondary style={{ textTransform: 'capitalize' }}>
                  {day}
                </Text>
              </Text>)}
          </View>
          <Spacer h={8}/>
          <Button brand style={[marginBottom, styles.button]} title="Continue" onPress={onSubmit}/>
        </View>
      </View>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: strings.SelectWeekday.shortTitle,
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styleSet = createStyleSheets((colors) => ({
    screenInfoHeader: {
        paddingBottom: rem(8),
    },
    columnWrapperStyle: {
        flex: 1,
    },
    eachButtonContainer: {
        flex: 1,
        margin: rem(8),
    },
    contentContainerStyles: {
        paddingHorizontal: rem(8),
    },
    buttonStyles: {
        flex: 1,
        height: rem(42),
        borderWidth: rem(1),
        alignItems: 'center',
        borderRadius: rem(12),
        justifyContent: 'center',
        borderColor: colors.cards.onDark,
        backgroundColor: colors.cards.onDark,
    },
    selectedContainer: {
        borderColor: colors.elements.brand,
    },
    infoContainer: {
        alignItems: 'center',
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
    },
    button: {
        marginHorizontal: rem(16),
    },
    daysWrapper: {
        paddingHorizontal: rem(8),
    },
}));
export default SelectWeekdayScreen;
